<div class="row clearfix">
  @for (a of mapData; track a) {
  @if (result) {
  <div [hidden]="a?.invisible"
    class="col-{{a.col? a.col : '6'}} text-left {{direction=='HORIZONTAL' ? 'horiz' : 'vertical'}}">
    <label class="text-body-emphasis text-nowrap d-flex justify-content-between">
      <div>
        {{a.title}}
      </div>
      <div>
        :&nbsp;
      </div>
    </label>
    @if (checkModify(a.name,a.type); as val) {
    @switch (a.type) {
    @case ('DATE') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''"
        [innerHTML]="val.oldValue | date: a.type =='DATE' ? 'dd-MMM-yyyy' : 'medium'"></span>
      @if (val.newValue) {
      <mark> {{val.newValue | date: a.type =='DATE' ? 'dd-MMM-yyyy' :
        'medium'}}</mark>
      }
    </p>
    }
    @case ('CURRENCY') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="+val.oldValue | currencyFormat"></span>
      @if (val.newValue) {
      <mark>{{+val.newValue | currencyFormat}}</mark>
      }
    </p>
    }
    @case ('BOOLEAN') {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="+val.oldValue ? 'YES' : 'NO'"></span>
      @if (val.newValue) {
      <mark>{{+val.newValue ? 'YES' : 'NO'}}</mark>
      }
    </p>
    }
    @case ('FILE') {
    <div class="imagediv">
      <image-doc-grid [src]="val?.newValue  || result[a.name + '_path']" [showDelete]="false"></image-doc-grid>
      @if (val.newValue) {
      <mark class="text-small">New Image</mark>
      }
    </div>
    }
    @case ('TEMPLATE') {
    <ng-container *ngIf="infoTemplate">
      <ng-container [ngTemplateOutlet]="infoTemplate"
        [ngTemplateOutletContext]="{colName:a?.name,formData:a}"></ng-container>
    </ng-container>
    }
    @default {
    @if (a.isClickable) {
    <p>
      <strong><a title="Info" (click)="openInfo(a.viewType,result[a.name])" href="javascript:void(0)">{{result[a.name]
          }}</a></strong>
    </p>
    }@else {
    <p>
      <span [class]="val?.newValue ? 'line-through' : ''" [innerHTML]="val.oldValue"></span>
      @if (val.newValue) {
      <mark>{{val.newValue}}</mark>
      }
    </p>
    }
    }
    }
    }
  </div>
  }
  }
</div>